import { History, TreePalm } from 'lucide-react';
import { LoadingSpinner } from '../../../components/loading/LoadingSpinner';
import { PlantHistoryItem } from '../../../components/plant/PlantHistoryItem';
import { PlantHistoryModal } from '../../../components/plant/PlantHistoryModal';

export function HistoryPanel({
  history,
  isLoading,
  selectedPlant,
  isModalOpen,
  onPlantClick,
  onModalClose
}) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <History className="w-5 h-5 text-emerald-600" />
        <h2 className="text-xl font-semibold">Recent Identifications</h2>
      </div>

      {isLoading ? (
        <div className="py-8">
          <LoadingSpinner />
        </div>
      ) : history.length === 0 ? (
        <div className="text-center text-gray-600 py-8">
          <TreePalm className="w-12 h-12 mx-auto mb-2 text-gray-400" />
          <p>No plant identifications yet</p>
          <p className="text-sm">
            Start by uploading or capturing a plant image above!
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {history.map((item, index) => (
            <PlantHistoryItem key={index} item={item} onClick={onPlantClick} />
          ))}
        </div>
      )}

      <PlantHistoryModal
        isOpen={isModalOpen}
        onClose={onModalClose}
        plant={selectedPlant}
      />
    </div>
  );
}
